<template>
  <div class="container">
    <div class="background">
      <img src="./../assets/images/private_img.jpg" alt="background"/>
    </div>
    <section class="section intro">
      <div class="content">
        <p class="section-header" v-html="$translations.get('private_bodies_header')">Our service</p>
        <p class="section-title" v-html="$translations.get('private_bodies_title')">Private bodies services</p>
        <p class="section-text" v-html="$translations.get('private_bodies_text')">
          Wagner-Hatfield works globally with market players, industry associations, research bodies and NGO’s. 
        </p>
      </div>
    </section>
    <section class="section about">
      <div class="background">
      </div>
      <div class="content">
        <div class="text-section">
          <p class="title" v-html="$translations.get('private_bodies_section_title')">About our private bodies
            services</p>
          <div class="text" v-html="$translations.get('private_bodies_section_text')">
            Our consultancy is based on our extensive knowledge and experience in public and private sector in the EMEA
            region and the United States. We use our knowledge, expertise and determination to help our clients in their
            endeavors, providing sound and research-based solutions to help them grow.  
            <br><br>
            We are dedicated to reconciling public interest and private entrepreneurship by addressing challenges such
            as efficiency and pragmatism of
            rules and legislations, innovation in public governance, impartiality of arbitration, as well as quality of
            working relationship between regulators and private actors.
            <br><br>
            Affirmation of shared commitments with our
            clients with dedication is our vision, based on diligence, resolve, progressiveness, innovation, excellence,
            integrity and competence.  
            <br><br>
            We can deliver tailored studies and analyses, and offer personalized advice and
            relevant business intelligence to work collaboratively with our clients on meeting the challenges and
            seizing the opportunities of an evolving sector.  
            <br><br>
            Our clients include various radio services providers,
            free and pay TV service providers, platform providers and industry associations, in Europe and beyond.      
          </div>
        </div>
      </div>
    </section>
    <section class="section contact">
      <div class="background">
      </div>
      <div class="content">
        <div class="text-section">
          <p class="header" v-html="$translations.get('contact_form_header')"></p>
          <p class="title" v-html="$translations.get('contact_form_title')"></p>
          <p class="text" v-html="$translations.get('contact_form_text')">
          </p>
          <form target="_blank" @submit="submitForm" class="contact-form"
                action="https://wagner-hatfield.com/formsubmit.php" method="POST">
            <input name="name" :class="[validations.name]" v-model="form.name"
                   :placeholder="$translations.get('contact_form_label_name')"/>
            <input name="phone" :class="[validations.phone]" v-model="form.phone"
                   :placeholder="$translations.get('contact_form_label_phone')"/>
            <input name="email" :class="[validations.email]" v-model="form.email"
                   :placeholder="$translations.get('contact_form_label_email')"/>
            <input name="company" :class="[validations.company]" v-model="form.company"
                   :placeholder="$translations.get('contact_form_label_company')"/>
            <textarea name="message" :class="[validations.message]" v-model="form.message"
                      :placeholder="$translations.get('contact_form_label_message')" rows="5"></textarea>
            <span class="submit">
              <input type="submit" name="submit" :value="$translations.get('contact_form_label_submit')">
            </span>
          </form>
        </div>
      </div>
    </section>
    <footer-section/>
  </div>
</template>

<script>
  import FooterSection from "@/components/FooterSection";

  export default {
    name: 'PrivateBodies',
    metaInfo: {
      title: "Private bodies"
    },
    components: {FooterSection},
    data: () => ({
      form: {
        name: "",
        phone: "",
        email: "",
        company: "",
        message: ""
      },
      validations: {
        name: "",
        phone: "",
        email: "",
        company: "",
        message: ""
      }
    }),
    methods: {
      submitForm: function (event) {
        let valid = true;
        if (!this.form.name) {
          valid = false;
          this.validations.name = "error";
        } else {
          this.validations.name = "";
        }
        if (!this.form.email) {
          valid &= false;
          this.validations.email = "error";
        } else {
          this.validations.email = "";
        }
        if(!valid){
          event.preventDefault() ;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .section {
    background: #fff;

    &.intro {
      background: transparent;

      .content {
        height: 70vh;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        flex-direction: column;
        padding-left: 4rem;
        padding-bottom: 4rem;
        box-sizing: border-box;

        .section-header {
          text-align: left !important;
          opacity: 0;
        }

        .section-title {
          text-align: left !important;
          opacity: 0;
        }

        .section-text {
          text-align: left !important;
          opacity: 0;
          max-width: 50vw !important;
        }
      }
    }

    &.contact {
      margin-top: 30vh;

      .content {

        .contact-form {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: stretch;
          max-width: 50vw;

          input {
            border: 0.1rem solid rgba(0, 0, 0, 0.3);
            font-size: 1rem;
            padding: 0.3em;
            margin: 0.6em 0;
            font-family: 'NeueHaasUnicaPro-Medium', sans-serif;

            &.error {
              border-color: #cc0000;
            }
          }

          textarea {
            border: 0.1rem solid rgba(0, 0, 0, 0.3);
            font-size: 1rem;
            padding: 0.3em;
            margin: 0.6em 0;
            resize: none;
            font-family: 'NeueHaasUnicaPro-Medium', sans-serif;

            &.error {
              border-color: #cc0000;
            }
          }

          .submit {
            position: relative;
            font-size: 0.7rem;
            cursor: pointer;
            text-decoration: none;
            align-self: flex-end;
            font-family: 'NeueHaasUnicaPro-Heavy', sans-serif;

            input {
              min-width: 0;
              background: none;
              border: none;
              text-transform: uppercase;
              cursor: pointer;
            }

            &::before {
              content: '';
              position: absolute;
              width: 1.5em;
              height: 100%;
              top: 0;
              left: -2em;
              //noinspection CssUnknownTarget
              background: url("./../assets/images/arrow.svg") center no-repeat;
              background-size: contain;
            }
          }
        }
      }
    }

    @include media-query(medium) {

      &.intro {

        .content {
          justify-content: center;
          align-items: center;
          padding-left: 0;
          padding-bottom: 0;

          .section-header {
            text-align: center !important;
          }

          .section-title {
            text-align: center !important;
          }

          .section-text {
            text-align: center !important;
            max-width: 90vw !important;
          }
        }
      }

      &.contact {

        .content {

          .contact-form {
            max-width: 100%;
          }
        }
      }
    }
  }

  .loaded {

    .intro {

      .title-header {
        @include animation(fadeIn 1s $default-ease 0s 1 forwards);
      }

      .title {
        @include animation(fadeIn 1s $default-ease 200ms 1 forwards);
      }

      .text {
        @include animation(fadeIn 1s $default-ease 400ms 1 forwards);
      }
    }
  }
</style>
